<template>
  <v-main>
    <v-container fluid>
      <v-flex xs12>
        <HowToUseThisPage />
        <div class="faqs-container">
          <div class="route-container mb-4">
            <h1><v-icon>$question_mark</v-icon> FAQ</h1>
          </div>
          <div class="mb-7 mt-12">
            <v-btn
              color="rgba(165, 216, 103, 1)"
              class="elevation-0 font-weight-bold"
              @click="addFaq"
              >CREATE NEW QUESTION</v-btn
            >
          </div>
          <v-expansion-panels
            v-model="openedPanel"
            variant="accordion"
            class="pt-13 pb-8 px-15 tj-elevation-1"
            :style="{
              background: this.$vuetify.theme.dark ? '#363636' : '#ffffff',
            }"
          >
            <div class="font-weight-bold text-body-2 mb-5 text-light-green">
              FREQUENTLY ASKED QUESTIONS
            </div>

            <draggable
              v-model="faqs"
              handle=".handle"
              group="people"
              @start="drag = true"
              @end="drag = false"
              @change="updatePositions"
            >
              <v-expansion-panel
                v-for="(item, i) in faqs"
                :key="i"
                class="mb-5"
              >
                <div
                  class="expansion-panel-header-container"
                  :class="item.default ? 'default' : ''"
                >
                  <div class="handle"><v-icon>$drag_icon</v-icon></div>
                  <span class="panel-header font-weight-bold">{{
                    item.question
                  }}</span>
                  <div class="action-icons">
                    <v-icon @click.native="togglePanel(i)">$edit</v-icon>
                    <v-icon
                      v-if="!isHelpDesk"
                      @click.native="deleteItem(item, 'faqs')"
                      >$delete_icon</v-icon
                    >
                  </div>
                </div>
                <v-expansion-panel-text>
                  <div class="snippet-autosave-header">
                    <div
                      class="snippet-autosave-status"
                      :class="'snippet-autosave-status-' + i"
                    >
                      <div class="snippet-autosave-status_label">Status:</div>
                      <div class="snippet-autosave-status_spinner">
                        <span
                          class="snippet-autosave-status_spinner-label"
                        ></span>
                        <span
                          class="snippet-autosave-status_spinner-loader"
                        ></span>
                      </div>
                    </div>
                  </div>
                  <v-text-field
                    v-model="item.question"
                    label="Question:"
                    hide-details="auto"
                    color="green"
                    class="mb-12"
                    @update:model-value="onTextChange(item, i)"
                  ></v-text-field>
                  <label class="v-label answer">
                    <span class="v-label--active">Answer:</span>
                  </label>
                  <CustomQuill
                    :id="'faqs-editor-' + i"
                    :class="'editor-' + i"
                    v-model:content="item.answer"
                    contentType="html"
                    :modules="customModulesForEditor"
                    :placeholder="editorSettings.placeholder"
                    @textChange="onTextChange(item, i)"
                  />

                  <div class="snippet-autosave-header">
                    <div
                      class="snippet-autosave-status"
                      :class="'snippet-autosave-status-' + i"
                    >
                      <div class="snippet-autosave-status_label">Status:</div>
                      <div class="snippet-autosave-status_spinner">
                        <span
                          class="snippet-autosave-status_spinner-label"
                        ></span>
                        <span
                          class="snippet-autosave-status_spinner-loader"
                        ></span>
                      </div>
                    </div>
                  </div>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </draggable>
          </v-expansion-panels>
        </div>
      </v-flex>
    </v-container>
  </v-main>
</template>

<script>
  // import firebase from 'firebase'
  import db from '@/firebase/init'
  import draggable from 'vuedraggable'
  import HowToUseThisPage from '@/components/utilities/HowToUseThisPage'
  import CustomQuill from '@/components/utilities/CustomQuill.vue'
  import 'quill/dist/quill.snow.css'
  import { editorSettings, customModulesForEditor } from '@/QuillConfig'
  import { confirmAction } from '@/components/utilities/SwalService'
  import Swal from 'sweetalert2'
  import { matchesConfirmWord } from '@/helpers/confirmWord'

  export default {
    name: 'Faqs',
    components: {
      draggable,
      HowToUseThisPage,
      CustomQuill,
    },
    data() {
      return {
        feedback: null,
        faqs: [],
        count: null,
        typingTimer: null,
        active: null,
        drag: false,
        openedPanel: null,
        editorSettings,
        customModulesForEditor,
      }
    },
    computed: {
      dragOptions() {
        return {
          animation: 200,
          group: 'description',
          disabled: false,
          ghostClass: 'ghost',
        }
      },
      isHelpDesk() {
        const roles = this.$store.getters['UserData/getRoles'] || []
        return roles.includes('helpDesk')
      },
    },
    methods: {
      togglePanel(index) {
        if (this.openedPanel == index) {
          this.openedPanel = null
        } else {
          this.openedPanel = index
        }
      },
      updatePositions() {
        // console.log('2 ', this.faqs)
        // originalEvent = originalEvent ? originalEvent : ''
        // evt = evt ? evt : ''
        // let i
        var batch = db.batch()
        this.faqs.forEach(function (doc, i) {
          // console.log(doc,i)
          // For each doc, add a delete operation to the batch
          let faqOrderRef = db.collection('faqs').doc(doc.id)
          batch.update(faqOrderRef, {
            order: i,
          })
        })
        // console.log('2 ', batch)
        batch.commit().then(() => {
          // console.log('3 ', this.faqs)
          this.faqs.forEach(function (part, index) {
            this[index].order = index
          }, this.faqs) // use arr as this
          // console.log('2.5 ', this.faqs)

          // this.faqs.sort((a, b) => (a.order > b.order) ? 1 : -1)
        })
      },
      addFaq() {
        db.collection('faqs')
          .add({
            question: 'Default question',
            answer: 'Lorum ipsum dummy text',
            deactivated: false,
            order: -1,
            default: true,
          })
          .then(() => {
            // console.log('added ', docRef, docRef.id)
            // this.faqs.sort((a, b) => (a.order > b.order) ? 1 : -1)
            this.getFaqs()
          })
      },
      // updateDeactivated(item) {
      //     item.deactivated = !item.deactivated
      //     db.collection('faqs').doc(item.id).update({
      //         deactivated: item.deactivated
      //     }).then(() => {
      //         // console.log('success')
      //     }).catch(err => {
      //         console.log(err)
      //     })
      // },
      startTypingTimer(item) {
        // console.log('start')
        clearTimeout(this.typingTimer)
        this.typingTimer = setTimeout(() => {
          this.save(item)
        }, 2000)
      },
      clearTypingTimer() {
        // console.log('clear')
        clearTimeout(this.typingTimer)
      },
      save(item) {
        // make sure order has a number
        let order = isNaN(item.order) ? null : item.order

        const statusIndicator = document.querySelectorAll(
          '.snippet-autosave-status, .quillWrapper'
        )

        // Lets debouce this
        if (this.timeout) clearTimeout(this.timeout)

        this.timeout = setTimeout(() => {
          // your action
          db.collection('faqs')
            .doc(item.id)
            .update({
              question: item.question,
              answer: item.answer,
              order: order,
              default: false,
            })
            .then(() => {
              // set time out is only used for user experience
              // setTimeout(() => {
              statusIndicator.forEach(function (item) {
                item.classList.remove('busy')
              })

              // removes the default property
              this.faqs.filter((faq) => {
                if (faq.id == item.id) {
                  faq.default = false
                }
              })

              // }, 300);
            })
            .catch((err) => {
              console.log(err)
            })
        }, 300)
      },
      async deleteItem(item, collection) {
        if (this.isHelpDesk) {
          const key = 'faqs.deleteNotAllowed'
          this.feedback =
            (this.$te && this.$te(key) ? this.$t(key) : null) ||
            'Help Desk users cannot delete FAQs.'
          return
        }

        if (item && collection) {
          const confirmed = await confirmAction({
            title: `You are about to delete: <br>"${item.question}"`,
            html: 'Type DELETE below to confirm.',
            input: 'text',
            inputPlaceholder: 'Type DELETE',
            inputValidator: (value) => {
              return new Promise((resolve) => {
                if (matchesConfirmWord(value, 'DELETE')) {
                  resolve()
                } else {
                  resolve('You need to type DELETE to confirm')
                }
              })
            },
            confirmButtonText: 'Yes Delete it!',
            cancelButtonText: 'No, Keep it!',
            context: this,
          })

          if (confirmed) {
            await db.collection(collection).doc(item.id).delete()
            this.faqs = this.faqs.filter((faq) => faq.id !== item.id)
          }
        } else {
          Swal.fire({
            title: 'Houston we have a problem.',
            text: 'Error with the delete function, missing params.',
            icon: 'error',
            confirmButtonClass:
              'v-btn v-btn--contained theme--dark v-size--default v-btn--depressed',
          })
        }
      },
      sortFaqs() {
        this.faqs.sort((a, b) => (a.order > b.order ? 1 : -1))
        // console.log('3 ', this.faqs)
        this.updatePositions()
      },
      getFaqs() {
        this.faqs = []
        let faqsRef = db.collection('faqs')
        faqsRef = faqsRef.orderBy('order')
        faqsRef.get().then((snapshot) => {
          snapshot.forEach((doc) => {
            let faq = doc.data()
            faq.id = doc.id
            this.faqs.push(faq)
          })
          // console.log('1 ', this.faqs)

          this.sortFaqs()
        })
      },
    },
    created() {
      this.getFaqs()
    },
  }
</script>

<style>
  .faqs-container {
    margin-bottom: 25%;
  }
  .faqs-container .v-expansion-panels > div {
    width: 100%;
  }
  .faqs-container .theme--light .v-expansion-panel--active {
    background-color: rgba(165, 216, 103, 0.14);
  }
  .faqs-container .theme--light .v-expansion-panel--active .quillWrapper {
    background-color: #ffffff;
  }
  .faqs-container .v-expansion-panel__header {
    cursor: grab;
  }
  .faqs-container .expansion-panel-header-container.default {
    background-color: rgba(165, 216, 103, 0.14);
  }
  .faqs-container .text-light-green {
    color: #a5d867;
  }
  .faqs-container label.answer span {
    position: absolute;
    transform: translateY(-18px) scale(0.75);
    transform-origin: top left;
  }
</style>
